const tabs = document.querySelectorAll('.tab');
console.log(tabs);
if(tabs.length > 0) {
  const firstTab = document.querySelector('.tab:first-child');
  firstTab.classList.add('is-active');
  const firstTabID = firstTab.getAttribute('id');

  const firstTabLink = document.querySelector(`a[href="#${firstTabID}"]`);
  firstTabLink.classList.add('is-active');
}


const tabLinks = document.querySelectorAll('a[data-toggle="tab"]');
if(tabLinks) {
  tabLinks.forEach((link) => {
    link.addEventListener('click', (event)=> {
      event.preventDefault();
      const target = event.target.getAttribute('href');
      const newTab = document.querySelector(target);
      const curTab = document.querySelector('.tab.is-active');
      curTab.classList.remove('is-active');

      const curTabBtn = document.querySelector('a[data-toggle="tab"].is-active');
      curTabBtn.classList.remove('is-active');

      newTab.classList.add('is-active');
      event.target.classList.add('is-active');
      return false;
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/util/tabs.js